var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-load-modal bg-black-trans font-family-lobster",attrs:{"id":"loading-modal"}},[_c('div',{staticClass:"load-modal"},[_vm._v("Cargando ...")]),_c('center',{staticClass:"fixed-bottom font-weight-bold"},[_vm._v("SORTEO")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }